import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // Only attempt fetching the profile if we have a token
        const hasToken = !!(localStorage.getItem('token'));
        if (!hasToken) {
          if (mounted) { setLoading(false); }
          return;
        }
        // Use the authenticated self-profile route
        const res = await api.get('/api/user/profile');
        if (!mounted) return;
        if (res?.data) {
          const p = { ...res.data };
          // normalize id fields for frontend compatibility
          if (!p._id && p.id) p._id = p.id;
          if (!p.id && p._id) p.id = p._id;
          setProfile(p);
          try { localStorage.setItem('user', JSON.stringify(p)); } catch (e) { /* ignore */ }
        }
      } catch (e) {
        // not authenticated or profile endpoint unavailable
        const status = e?.response?.status;
        // If token is invalid/expired (401), clear local auth to avoid repeated failures
        if (status === 401) {
          try { localStorage.removeItem('user'); localStorage.removeItem('token'); } catch (ex) {}
        }
        setProfile(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <ProfileContext.Provider value={{ profile, loading, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}

export default ProfileContext;
